import { InjectedConnector as BaseInjectedConnector } from '@web3-react/injected-connector';
export class InjectedConnector extends BaseInjectedConnector {
    constructor(chainId) {
        super({
            supportedChainIds: [chainId]
        });
    }
}
//# sourceMappingURL=InjectedConnector.js.map